export function changeMimeType(
  blob: Blob,
  newMime: "video/mp4"
): Blob {
  const newBlob = new Blob([blob], {
    type: newMime,
  })
  return newBlob
}
